import { ADMIN_SIDEBAR_OPTIONS, React, SidebarAction, SIDEBAR_OPTIONS, Style, SubSidebarListItem, 
         SubSidebarListItemWithSubMenu, useEffect, useRouter, useState, useNavbarStatus,
         selectSidebarOptionFromUrl, SubsidebarAction, useTranslation } from  '@/imports-files/components/sidebar';


export function SubSidebar(props)
{
    const router                                        =   useRouter();
    const { t }                                         =   useTranslation();
    const sidebarAction                                 =   new SidebarAction(router, t);
    const OPTIONS                                       =   sidebarAction.getSidebarOptions(props);
    const { navbarStatus, updateNavbarStatus }          =   useNavbarStatus();
    const [pagekey, setPageKey]                         =   useState(navbarStatus.key);
    const [subsidebarOptions, setSubsidebarOptions]     =   useState(OPTIONS[pagekey]['subSidebar_options']);
    const subsidebarAction                              =   new SubsidebarAction(navbarStatus, router, setPageKey, updateNavbarStatus, setSubsidebarOptions, OPTIONS);
    const [isLoading, setLoading]                       =   useState(true);

    useEffect(() => {   
                        subsidebarAction.handle_setting_subsidebar();
                    },[props.flagForRerender , props.pagekey])

    useEffect(() => {   
                         const handleRouteChange = (url) => { 
                                                                var value = selectSidebarOptionFromUrl( url, navbarStatus )
                                                                updateNavbarStatus(value);
                                                                var navbarStatus =  JSON.parse(localStorage.getItem('navbarStatus'));
                                                                var key          =  navbarStatus.key; 
                                                                setPageKey(key);
                                                                setSubsidebarOptions(OPTIONS[key]['subSidebar_options']);
                                                                sidebarAction.deactiveAllSidebarOption();
                                                                sidebarAction.activateSidebarOption(document.getElementById(key));
                                                                sidebarAction.activateSubsidebar( OPTIONS[key], key , navbarStatus, url);
                                                            }

                        router.events.on('routeChangeComplete', handleRouteChange);
                        subsidebarAction.handle_setting_subsidebar_firstload();
                       
                        return () => {
                                        router.events.off('routeChangeComplete', handleRouteChange);
                                    }

                        
                },[])
    return (   
                <div className={`SubSidebar ${subsidebarAction.setSubsidebarClass()} ${Style.SubSidebar}`}>
                    
                    <div className={`SubSidebar__List ${Style.SubSidebar__List}`}>
                        { OPTIONS[JSON.parse(localStorage.getItem('navbarStatus')).key]['type'] == "menu" ? <SubSidebarListItemWithSubMenu  options               =  {subsidebarOptions} 
                                                                                                                                            userRole              =  {props.userRole}
                                                                                                                                            currentRole           =  {props.currentRole}
                                                                                                                                            setPageKey            =   {props.setPageKey}/> 
                                                                    : <SubSidebarListItem  options              =  {subsidebarAction.setSubSidarSequence(subsidebarOptions, props.currentRole)}
                                                                                           userRole             =  {props.userRole}
                                                                                           currentRole          =  {props.currentRole}
                                                                                           setPageKey           =  {props.setPageKey}/> }
                    </div>

                    <div className={Style.SubSidebar__TopRightCurveSection}>
                        <div className={Style.SubSidebar__TopRightCurve}></div>
                    </div>

                    <div className={Style.SubSidebar__BottomRightCurveSection}>
                        <div className={Style.SubSidebar__BottomRightCurve}></div>
                    </div>

                </div> 
            )
}